import React from 'react';

const ViewHistoryIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.266 16.0596C5.11187 17.7703 6.48407 19.1645 8.181 20.0376C9.86551 20.903 11.7864 21.1951 13.652 20.8696C15.5233 20.5403 17.2377 19.6141 18.539 18.2296C19.852 16.8317 20.688 15.0535 20.927 13.1506C21.1693 11.2434 20.804 9.30826 19.883 7.62061C18.9705 5.9458 17.5441 4.60843 15.814 3.80561C14.0957 3.00978 12.1646 2.79631 10.314 3.19761C8.464 3.59861 6.948 4.51061 5.694 5.95261C5.543 6.11261 4.959 6.75861 4.474 7.73361M7.5 7.99961L3.891 8.71961L3 4.99961M12 8.99961V12.9996L15 14.9996'
        stroke='#5C5963'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ViewHistoryIcon;
